import EditRoom from './EditRoomContainer';

export default EditRoom;
